import { createContext } from "react";
const ContactsContext = createContext("Contacts context");

export default ContactsContext;
